import React, { useEffect, useState, useRef, createRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import TituloComponent from '../../components/Titulo/TituloComponent';
import Carregando from '../../components/Carregando/Carregando';
import { buscarPedidos } from '../../services/api';
import { darAndamentoAoPedido } from '../../services/api';

// import { useSwipeable } from 'react-swipeable';

// css
import '../../styles/global.css';
import './PedidosPage.css';
import BotaoAndamentoPedido from '../../components/BotaoAndamentoPedido/BotaoAndamentoPedido';

/* eslint-disable no-restricted-globals */

const Pedidos = () => {
  const navigate = useNavigate();
  
  // Pega os dados da sessão diretamente
  const userData = JSON.parse(sessionStorage.getItem('userData')); // Assume que os dados estão armazenados no sessionStorage
  const statusUsuario = userData?.statusUsuario;
  const nomePerfil = userData?.dadosPerfil?.nome;
  const nomeUsuario = userData?.user.name;
  const [pedidos, setPedidos] = useState([]);
  const [carregando, setCarregando] = useState(true);

  const [wakeLock, setWakeLock] = useState(null);

  // const refs = useRef([]);

  // buscar os pedidos periodicamente
  const [intervalId, setIntervalId] = useState(null);
  const [isAuthorized, setIsAuthorized] = useState(true);

  // tentativa de fazer com que a tela do telefone não apague
  useEffect(() => {
    const requestWakeLock = async () => {
      try {
        const wakeLock = await navigator.wakeLock.request('screen');
        setWakeLock(wakeLock);
      } catch (error) {
        console.error('Erro ao solicitar wake lock:', error);
      }
    };

    requestWakeLock();

    return () => {
      if (wakeLock) {
        wakeLock.release();
      }
    };
  }, []);

  useEffect(() => {
    // Verifica se o usuário tem o perfil correto e está logado
    console.log('Perfil: ');
    console.log(userData.dadosPerfil?.nome);

    if (
      !userData || 
      (
        userData.dadosPerfil?.nome !== 'BAR BARMAN' && 
        userData.dadosPerfil?.nome !== 'BAR GARCON' && 
        userData.dadosPerfil?.nome !== 'BAR COZINHA'
      ) || 
      userData.statusUsuario !== 'logado') {
        console.log(' !!!! Perfil não autorizado ou usuário não logado. Redirecionando...');
        setIsAuthorized(false); // Atualiza o estado de autorização
        navigate('/area-restrita'); // Redireciona para a página de login ou área restrita
    } else {
      console.log('--- PAGINA PEDIDOS ---');
      console.log('Dados completos do usuário:', userData);
      console.log('Status do usuário:', statusUsuario);
      console.log('Perfil do usuário:', nomePerfil);

      atualizarStatus();
      buscarProdutos();
    }
  }, []);

  useEffect(() => {
    const id = setInterval(fetchPedidos, 10000); // 30 segundos
    setIntervalId(id);
    return () => clearInterval(id);
  }, []);


  

  // useEffect(() => {
  //   // Cria refs apenas quando pedidos são recebidos
  //   refs.current = pedidos.map(() => createRef());
  // }, [pedidos]);


  // vamos buscar os pedidos para o bar
  const buscarProdutos = async () => {
    try {
      // buscar todos os produtos do estabelecimento
      await fetchPedidos();
      setCarregando(false);
    } catch (error) {
      console.error('Erro ao buscar os produtos:', error);
    }
  };

  const atualizarStatus = async () => {
    console.log('!!! Entrou em atualizarStatus !!!');
    console.log('userData: ');
    console.log(userData);

    const perfil = userData.dadosPerfil?.nome;

    console.log('Perfil: ');
    console.log(perfil);

    const updatedUserData = perfil === 'BAR GARCON'
      ? { ...userData, status: 'PEDIDO LIBERADO PARA O GARCON', proximoStatus: 'PEDIDO ENTREGUE AO CLIENTE' }
      : { ...userData, status: 'PEDIDO FEITO PELO CLIENTE', proximoStatus: 'PEDIDO LIBERADO PARA O GARCON' };
    
    await new Promise(resolve => {
      sessionStorage.setItem('userData', JSON.stringify(updatedUserData));
      resolve();
    });


    await new Promise(resolve => {
      sessionStorage.setItem('userData', JSON.stringify(updatedUserData));
      resolve();
    });
}

  // buscar todos os produtos do estabelecimento, para checkar os que já tem
  const fetchPedidos = async () => {
    console.log('Entrou em fetchPedidos em PedidosPage');

    console.log('!!!!! Foco forçado !!!!!');

    const userData = JSON.parse(sessionStorage.getItem('userData'));

    // atualizarStatus();

    console.log('userData: ');
    console.log(userData);
    try {
      const dados = await buscarPedidos(userData);

      console.log('*** pedidos ***', dados.pedidos);

      if (dados?.pedidos) {
        console.log('-> Pedidos: ', dados.pedidos);
        setPedidos(dados.pedidos);
      }
    } catch (error) {
      console.error('Erro ao buscar produtos:', error);
    }
  };

  // Função para fazer o logout
  const handleLogout = () => {
    // Remove os dados da sessão
    sessionStorage.removeItem('userData');
    // Redireciona para a página de login
    navigate('/area-restrita');
  };

  const handleDarAndamento = async () => {
    await buscarProdutos();
  };
  

  // se o usuário não estiver autorizado
  if (!isAuthorized) {
    return <div>Redirecionando...</div>;
  }

  if (carregando) {
    return <Carregando />;
  }

  return (
    <div autoFocus className="fichas-container">
      <TituloComponent />

      <h1 className="sub-titulo">Área de Pedidos</h1>
      
      <div className="box-dados">
        <p className="texto-welcome">Bem-vindo, {nomeUsuario}!</p>
        <p>Função: {nomePerfil}</p>
        <button className="welcome-btn" onClick={handleLogout}>Logout</button>
      </div>

      {/* Container de quadros */}
      {pedidos.map((pedido, index) => (

          console.log('pedido = ', pedido),

          <div
          // Chave composta, pois um mesmo pedido pode ter mais de um produto.
            key={`${pedido.id}-${pedido.produto_estabelecimento_id}`}  
            data-index={index} // O índice para o swipeHandler identificar
            data-id={pedido.id} // O ID do pedido
            className="box-dados-ficha"
          >

          <p className="texto-ficha-numero">{pedido.produto_pedido_id}</p>
          <p className="texto-welcome">Cliente: {pedido.nome_do_cliente}</p>

          <div className="divisor">&nbsp;</div>
          
          <p className="texto-ficha-nome-produto">{pedido.nome_produto}</p>

          <div className="divisor">&nbsp;</div>
          
          <p className="texto-welcome">Quantidade: {pedido.quantidade}</p>
          <p className="texto-welcome">Mesa: {pedido.numero_mesa} - Comanda: {pedido.numero_comanda}</p>
          <p className="texto-welcome">Data: {pedido.data_pedido} - {pedido.hora_pedido}</p>
          {/* <p className="texto-ficha-preco">R$ {pedido.preco}</p> */}


          <div onClick={handleDarAndamento}>
            <BotaoAndamentoPedido 
              idPedido={pedido.id}
              idProdutoEstabelecimento={pedido.produto_estabelecimento_id}
            />
          </div>

        </div>
      ))}
    </div>
  );
};

export default Pedidos;
